import { Box, Button, Icon, Typography } from "@outschool/backpack";
import { faCalendar, faChevronRight } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function ActivityEnrollableTimesCta({
  onRequestAnotherTimeClick,
  onClickViewAvailability,
  hasOneOnOneAvailabilities,
  shouldHideAlert = false,
}: {
  onRequestAnotherTimeClick: () => void;
  onClickViewAvailability: (event: React.SyntheticEvent) => void;
  hasOneOnOneAvailabilities: boolean;
  shouldHideAlert?: boolean;
}) {
  const { t } = useTranslation(
    "ui-components-website\\ClassDetailsPage\\ActivityEnrollableTimes"
  );
  return hasOneOnOneAvailabilities ? (
    <Button
      variant="contained"
      onClick={(e: React.SyntheticEvent<Element, Event>) =>
        onClickViewAvailability(e)
      }
    >
      {t`View Availability`}
    </Button>
  ) : (
    <>
      {!shouldHideAlert && (
        <Box flex sx={{ flexBasis: "100%" }}>
          <Typography
            sx={{
              backgroundColor: "#fffaea",
              borderColor: "warning.500",
              borderRadius: "0.25em",
              borderStyle: "solid",
              borderWidth: "1px",
              padding: "0.5em",
            }}
          >
            <Icon
              icon={faCalendar}
              color="warning"
              sx={{
                paddingRight: "0.25em",
              }}
            />
            {!!onRequestAnotherTimeClick
              ? t`Lesson available on request only.`
              : t`There are no available time slots for this class.`}
          </Typography>
        </Box>
      )}
      {!!onRequestAnotherTimeClick ? (
        <Button
          variant="contained"
          onClick={() => {
            onRequestAnotherTimeClick();
          }}
        >{t`Request a Meeting`}</Button>
      ) : (
        <Button
          variant="contained"
          disabled
          endIcon={<Icon icon={faChevronRight} />}
        >
          {t`View Availability`}
        </Button>
      )}
    </>
  );
}
